export default (t) => {
  const splitted = t.replace(/_/g, " ")
  return splitted[0].toUpperCase() + splitted.substring(1)
}
